exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(true);
// imports
exports.i(require("-!../../../node_modules/css-loader/index.js?{\"minimize\":true,\"sourceMap\":true}!../../../node_modules/font-awesome/css/font-awesome.css"), "");

// module
exports.push([module.id, ".paragraphText[data-v-47c36ace]{font-size:16px}.productNameTextSize[data-v-47c36ace]{font-size:18px}", "", {"version":3,"sources":["/home/winner/Documents/PROJECTS/LIGABLOFOOD/WEB/ligabloFood/src/components/auth/SignUp.vue"],"names":[],"mappings":"AACA,gCACI,cAAgB,CACnB,AACD,sCACI,cAAgB,CACnB","file":"SignUp.vue","sourcesContent":["\n.paragraphText[data-v-47c36ace]{\n    font-size: 16px;\n}\n.productNameTextSize[data-v-47c36ace]{\n    font-size: 18px;\n}\n@import \"../../../node_modules/font-awesome/css/font-awesome.css\";\n"],"sourceRoot":""}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"minimize":true,"sourceMap":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-47c36ace","scoped":true,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/auth/SignUp.vue
// module id = 307
// module chunks = 2